import { useMemo, useState } from 'react';

import quotes from '../data/quotes.json';

export const useLoadingScreen = () => {
  const [randomIndex] = useState(() => {
    const lastIndex = quotes.length - 1;

    return Math.round(Math.random() * lastIndex);
  });

  const randomQuote = useMemo(() => {
    return quotes[randomIndex];
  }, [randomIndex]);

  return {
    randomQuote,
  };
};
